module.exports = __webpack_public_path__ + "33531b1748f48ec461a5ea244539aa68.svg";